// Constants
export const predeterminados = () => {
  return {
    predeterminados: {      
      id: {
        namepath: ['configuracion'],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: null
        }
      },
      tabla: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
      campo: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
      predeterminado: {
        namepath: ['configuracion'],
        type: 'text',
        label: 'Nombre del Servicio',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: '',
        }   
      }, 
    }
  }
}
